import React from 'react';
import QuestionGroupHeader from '../QuestionGroupHeader.jsx';
import classNames from 'classnames';
import {QuestionGroupViewPropTypes} from '../../../shapes/index.mjs';

const Base = (props) => {
  const {
    questionGroup,
    renderChildren,
    className
  } = props;

  const classes = classNames(
    className,
    'questionGroup--base'
  );

  return (
    <section className={ classes }>
      <QuestionGroupHeader questionGroup={ questionGroup }/>
      { renderChildren() }
    </section>
  );
};

Base.propTypes = QuestionGroupViewPropTypes;

export default Base;
